/* src/app/components/public/about/about.component.scss */
.about-container {
  background: #aaaaaa;
  color: #000000;
  text-align: justify;
  padding: 100px 0;
  line-height: normal;
  font-size: 18px;
}
/*# sourceMappingURL=about.component.css.map */
